import React from "react";
import { useNavigate } from "react-router-dom";
import RegisterForm from "../components/RegisterForm";
import AuthService from "../services/AuthService";
import { useForm } from "react-hook-form";
import { showSuccessToast, showErrorToast } from "../utils/AlertUtils";
import { useLoading } from "../context/LoadingContext";

function Register() {
  const { setIsLoading } = useLoading();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    unregister,
    setValue,
    getValues,
  } = useForm({
    onSubmit: true
  });

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const response = await AuthService.register(data);
      if (response) {
        showSuccessToast(response.message);
        navigate("/login");
      }
    } catch (err) {
      showErrorToast(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <RegisterForm
      onSubmit={onSubmit}
      register={register}
      errors={errors}
      trigger={trigger}
      handleSubmit={handleSubmit}
      unregister={unregister}
      setValue={setValue}
      getValues={getValues} // Pass getValues prop
    />
  );
}

export default Register;
